interface RppTitleProps {
    title?: string
}

export const RppTitle = ({
    title
}: RppTitleProps) => {
    return (
        <title>
            {`RPM ${title}`}
        </title>
    )
}
